{
  "admin_user": {
    "title": "Người dùng Admin",
    "subtitle": "Tài khoản nhân viên",
    "columns": {
      "name": "Tên",
      "email": "Email",
      "role": "Vai trò",
      "roleType": "Loại vai trò",
      "saleAssigned": "Sale phụ trách",
      "csAssigned": "CS phụ trách",
      "lastLogin": "Đăng nhập gần nhất",
      "isActive": "Đang hoạt động",
      "createdAt": "Ngày tạo",
      "user": "Người dùng",
      "roles": "Vai trò",
      "status": "Trạng thái",
      "twoFactor": "2FA",
      "updated": "Cập nhật",
      "actions": "Hành động"
    },
    "actions": {
      "create": "Tạo người dùng",
      "edit": "Sửa",
      "deactivate": "Vô hiệu hóa",
      "activate": "Kích hoạt",
      "resetPassword": "Đặt lại mật khẩu",
      "impersonate": "Đóng vai",
      "assignSale": "Gán Sale",
      "assignCs": "Gán CS",
      "revokeCredit": "Thu hồi tín dụng",
      "editCredit": "Sửa hạn mức tín dụng"
    },
    "filters": {
      "role": "Vai trò",
      "roleType": "Loại vai trò",
      "saleAssigned": "Sale phụ trách",
      "csAssigned": "CS phụ trách",
      "status": "Trạng thái",
      "search": "Tìm theo tên hoặc email",
      "allRoles": "Tất cả vai trò",
      "allStatuses": "Tất cả trạng thái"
    },
    "tabs": {
      "details": "Chi tiết",
      "permissions": "Quyền",
      "credit": "Tín dụng",
      "auditLog": "Audit Log"
    },
    "fields": {
      "fullName": "Họ và tên",
      "email": "Email",
      "phone": "Số điện thoại",
      "role": "Vai trò",
      "password": "Mật khẩu",
      "confirmPassword": "Xác nhận mật khẩu",
      "isActive": "Đang hoạt động"
    },
    "empty": {
      "title": "Không tìm thấy người dùng",
      "body": "Điều chỉnh bộ lọc hoặc tạo người dùng mới."
    },
    "errors": {
      "duplicateEmail": "Đã tồn tại người dùng với email này",
      "weakPassword": "Mật khẩu phải dài ít nhất 12 ký tự, có chữ hoa, chữ thường và số",
      "passwordMismatch": "Mật khẩu không khớp",
      "cannotImpersonate": "Bạn không có quyền đóng vai người dùng này",
      "cannotDeactivateSelf": "Không thể vô hiệu hóa tài khoản của chính mình"
    },
    "confirm": {
      "deactivate": "Vô hiệu hóa người dùng này? Họ sẽ mất quyền truy cập ngay lập tức.",
      "resetPassword": "Gửi email đặt lại mật khẩu cho người dùng này?",
      "impersonate": "Đóng vai người dùng này? Hành động của bạn sẽ được ghi audit."
    },
    "page": {
      "heading": "Quản lý tài khoản admin",
      "subtitleWithTotal": "Quản lý vai trò, đình chỉ, đặt lại 2FA và đóng vai. Tổng cộng {{total}} người dùng."
    },
    "search": {
      "placeholder": "Tìm theo email hoặc tên…"
    },
    "rowActions": {
      "grant": "Cấp quyền",
      "revoke": "Thu hồi",
      "suspend": "Đình chỉ",
      "unsuspend": "Bỏ đình chỉ",
      "reset2fa": "Đặt lại 2FA",
      "selfGuard": "Không thể chỉnh sửa tài khoản của chính bạn"
    },
    "twoFactor": {
      "enabledTitle": "2FA đã bật",
      "disabledTitle": "2FA chưa bật",
      "badgeOn": "2FA",
      "badgeOff": "Tắt"
    },
    "avatar": {
      "viewAlt": "Xem ảnh đại diện của {{name}}"
    },
    "roleOptions": {
      "superadmin": "Superadmin",
      "admin": "Admin",
      "support": "Hỗ trợ",
      "saler": "Sale",
      "manager": "Quản lý",
      "accountant": "Kế toán",
      "affiliate": "Cộng tác viên"
    },
    "accountTypes": {
      "merchant": "Merchant",
      "vendor": "Nhà cung cấp",
      "affiliate": "Cộng tác viên"
    },
    "statusLabels": {
      "active": "Đang hoạt động",
      "pending_otp": "Chưa xác minh",
      "pending_approval": "Chờ duyệt",
      "pending_survey": "Chờ khảo sát",
      "suspended": "Đã đình chỉ",
      "banned": "Đã cấm",
      "deleted": "Đã xóa",
      "inactive": "Ngừng hoạt động"
    },
    "drawer": {
      "aria": "Chi tiết tài khoản {{name}}",
      "close": "Đóng",
      "closeAria": "Đóng drawer",
      "viewAvatarAria": "Xem ảnh đại diện {{name}}",
      "fields": {
        "status": "Trạng thái",
        "twoFactor": "2FA",
        "roles": "Vai trò",
        "id": "ID",
        "createdAt": "Tạo lúc",
        "updatedAt": "Sửa lúc",
        "lastLoginAt": "Đăng nhập gần nhất",
        "avatarUrl": "Avatar URL"
      },
      "neverLoggedIn": "Chưa từng",
      "avatarFallback": "— (dùng chữ cái đầu)",
      "viewFull": "Xem chi tiết đầy đủ →",
      "fullIncludes": "Bao gồm quyền, hoạt động, phiên đăng nhập"
    },
    "roleDialog": {
      "titleGrant": "Cấp vai trò — {{name}}",
      "titleRevoke": "Thu hồi vai trò — {{name}}",
      "roleLabel": "Vai trò",
      "rolePlaceholder": "Chọn vai trò…",
      "noRevocableRoles": "Người dùng này không có vai trò nào để thu hồi.",
      "reasonLabel": "Lý do (audit, 10-500 ký tự)",
      "cancel": "Hủy",
      "grant": "Cấp quyền",
      "revoke": "Thu hồi"
    },
    "confirmAction": {
      "suspendTitle": "Đình chỉ {{name}}?",
      "unsuspendTitle": "Bỏ đình chỉ {{name}}?",
      "reset2faTitle": "Đặt lại 2FA cho {{name}}?",
      "suspendDesc": "Áp dụng dây chuyền tới các thành viên nhóm. Tất cả phiên bị thu hồi.",
      "unsuspendDesc": "Khôi phục người dùng về trạng thái Đang hoạt động.",
      "reset2faDesc": "Xóa đăng ký TOTP + mã khôi phục. Mức nhạy cảm Tier A.",
      "reasonPlaceholder": "Lý do (10-500 ký tự, nhật ký kiểm toán)",
      "confirmLabel": "Xác nhận",
      "reasonRequiredTitle": "Bắt buộc nhập lý do",
      "reasonRequiredDesc": "Tối thiểu 10 ký tự cho nhật ký kiểm toán."
    },
    "toast": {
      "loadFailTitle": "Không tải được danh sách người dùng",
      "networkErrorTitle": "Lỗi mạng",
      "unknown": "Không xác định",
      "actionFailTitle": "Hành động thất bại",
      "unknownError": "Lỗi không xác định",
      "suspendedTitle": "Đã đình chỉ người dùng",
      "unsuspendedTitle": "Đã bỏ đình chỉ người dùng",
      "reset2faTitle": "Đã đặt lại 2FA của người dùng",
      "roleUpdateFailTitle": "Cập nhật vai trò thất bại",
      "roleGrantedTitle": "Đã cấp vai trò",
      "roleRevokedTitle": "Đã thu hồi vai trò"
    },
    "createDialog": {
      "title": "Tạo tài khoản quản trị",
      "fields": {
        "email": "Email",
        "displayName": "Tên hiển thị",
        "role": "Vai trò"
      },
      "roleOptions": {
        "admin": "Admin",
        "support": "Support Admin",
        "saler": "Saler",
        "manager": "Manager",
        "accountant": "Kế toán",
        "affiliate": "Affiliate"
      },
      "checkbox": {
        "title": "Gửi email mời",
        "onLabel": "Gửi email mời ngay sau khi tạo tài khoản",
        "offLabel": "Không gửi email mời (admin sẽ gửi sau)",
        "help": "Bỏ chọn để tạo tài khoản trước, gửi email mời sau từ trang chi tiết."
      },
      "submitInvite": "Tạo & gửi mời",
      "submitInviteLoading": "Đang tạo & gửi mời…",
      "submitNoInvite": "Tạo (không gửi mời)",
      "submitNoInviteLoading": "Đang tạo…",
      "toast": {
        "successInvite": "Đã tạo tài khoản và gửi email mời (1 gửi thành công)",
        "successNoInvite": "Đã tạo tài khoản (chưa gửi email mời)",
        "failTitle": "Không thể tạo tài khoản",
        "failDesc": "Mạng không phản hồi."
      }
    }
  },
  "detail": {
    "back": "Quay lại Người dùng",
    "backToList": "Quay về danh sách",
    "missingId": "Thiếu mã tài khoản trên URL.",
    "loadError": "Không thể tải chi tiết tài khoản: {{message}}",
    "unknownError": "Lỗi không xác định.",
    "additionalRoles": "+ {{count}} vai trò phụ",
    "selfBanner": "Đây là tài khoản của bạn — bạn không thể tự khoá hoặc tự đăng xuất tất cả phiên ở đây.",
    "tabs": {
      "profile": "Hồ sơ",
      "permissions": "Vai trò & Quyền",
      "activity": "Hoạt động",
      "sessions": "Phiên đăng nhập"
    },
    "statusLabels": {
      "active": "Đang hoạt động",
      "inactive": "Tạm khoá",
      "locked": "Đã khoá"
    },
    "activity": {
      "totalPrefix": "Tổng",
      "totalSuffix": "hoạt động.",
      "categoryOptions": {
        "all": "Tất cả hoạt động",
        "login": "Đăng nhập",
        "role_change": "Thay đổi vai trò",
        "security": "Bảo mật",
        "page_visit": "Trang gần đây"
      },
      "categoryBadge": {
        "login": "Đăng nhập",
        "role_change": "Vai trò",
        "security": "Bảo mật",
        "page_visit": "Truy cập"
      },
      "loadError": "Không thể tải hoạt động:",
      "empty": "Chưa có hoạt động nào trong nhóm này.",
      "columns": {
        "type": "Loại",
        "event": "Sự kiện",
        "detail": "Chi tiết",
        "ipDevice": "IP / Thiết bị",
        "time": "Thời gian"
      },
      "pageLabel": "Trang:",
      "loadingMore": "Đang tải...",
      "loadMore_one": "Tải thêm {{count}} dòng",
      "loadMore_other": "Tải thêm {{count}} dòng",
      "events": {
        "ADMIN_ROLE_CREATE": "Tạo vai trò admin",
        "ADMIN_ROLE_DELETE": "Xoá vai trò admin",
        "ADMIN_ROLE_UPDATE": "Cập nhật vai trò admin",
        "ADMIN_USER_2FA_SETUP": "Thiết lập 2FA cho người dùng",
        "ADMIN_USER_CREATE": "Tạo tài khoản admin",
        "ADMIN_USER_ROLE_GRANT_INITIAL": "Gán vai trò ban đầu",
        "AUTH_2FA_CHALLENGE": "Yêu cầu xác thực 2FA",
        "AUTH_2FA_DISABLED": "Tắt 2FA",
        "AUTH_2FA_SETUP": "Thiết lập 2FA",
        "AUTH_2FA_VERIFY": "Xác thực 2FA thành công",
        "AUTH_BILLING_UPDATE": "Cập nhật thông tin thanh toán",
        "AUTH_IMPERSONATE_START": "Bắt đầu đăng nhập hộ",
        "AUTH_LOGIN": "Đăng nhập",
        "AUTH_LOGIN_FAILED": "Đăng nhập thất bại",
        "AUTH_LOGIN_LOCKED": "Khoá tài khoản do đăng nhập sai nhiều lần",
        "AUTH_LOGOUT": "Đăng xuất",
        "AUTH_PASSWORD_CHANGE": "Đổi mật khẩu",
        "AUTH_PROFILE_UPDATE": "Cập nhật hồ sơ",
        "AUTH_REFRESH": "Làm mới phiên đăng nhập",
        "AUTH_REFRESH_FAILED": "Làm mới phiên thất bại",
        "AUTH_REGISTER": "Đăng ký tài khoản",
        "AUTH_SESSION_REVOKED": "Thu hồi phiên đăng nhập",
        "AUTH_SURVEY_SUBMIT": "Gửi khảo sát",
        "AUTH_USER_2FA_RESET": "Reset 2FA của người dùng",
        "AUTH_USER_ROLE_GRANT": "Gán vai trò",
        "AUTH_USER_ROLE_REVOKE": "Thu hồi vai trò",
        "AUTH_USER_SUSPEND": "Tạm ngưng người dùng",
        "AUTH_USER_UNSUSPEND": "Bỏ tạm ngưng người dùng",
        "AUTH_USER_UPDATE": "Cập nhật người dùng",
        "AUTH_VENDOR_APPROVE": "Duyệt nhà cung cấp",
        "AUTH_WS_SUBSCRIBE_DENIED": "Từ chối kết nối realtime",
        "EMAIL_TEMPLATE_CREATE": "Tạo mẫu email",
        "FRAUD_SETTINGS_UPDATED": "Cập nhật cấu hình chống gian lận",
        "INVENTORY_OVERVIEW_VIEW": "Xem tổng quan kho",
        "INVENTORY_REPORT_AGING_EXPORT": "Xuất báo cáo tồn kho theo tuổi",
        "INVENTORY_REPORT_MOVEMENT_EXPORT": "Xuất báo cáo biến động kho",
        "INVENTORY_REPORT_STOCK_LEVEL_EXPORT": "Xuất báo cáo mức tồn kho",
        "INVENTORY_REPORT_TURNOVER_EXPORT": "Xuất báo cáo vòng quay kho",
        "INVENTORY_REPORT_VALUATION_EXPORT": "Xuất báo cáo giá trị kho",
        "INVENTORY_STOCK_VIEW": "Xem danh sách tồn kho",
        "KYC_DOCUMENT_APPROVED": "Duyệt hồ sơ KYC",
        "LEGAL_ENTITY_CREATED": "Tạo pháp nhân",
        "PRODUCT_APPROVAL_APPROVED": "Duyệt sản phẩm",
        "SYSTEM_BACKUP_TRIGGERED": "Kích hoạt sao lưu hệ thống",
        "VENDOR_BANK_VERIFIED": "Xác minh tài khoản ngân hàng nhà cung cấp",
        "admin_invoice_pdf_download": "Tải PDF hoá đơn",
        "admin_payment_request_create": "Tạo yêu cầu thanh toán",
        "admin_payment_request_pdf_download": "Tải PDF yêu cầu thanh toán",
        "approval_request_executed": "Thực thi yêu cầu phê duyệt",
        "approval_request_rejected": "Từ chối yêu cầu phê duyệt",
        "approval_request_voted": "Bỏ phiếu yêu cầu phê duyệt",
        "billing_invoice_manually_generated": "Tạo hoá đơn thủ công",
        "billing_mode_switched": "Đổi chế độ thanh toán",
        "billing_refund_task_completed": "Hoàn tất tác vụ hoàn tiền",
        "billing_address_create": "Tạo địa chỉ thanh toán",
        "blueprint_create": "Tạo blueprint",
        "blueprint_update": "Cập nhật blueprint",
        "invoice_pdf_download": "Tải PDF hoá đơn",
        "merchant_invoice_created": "Tạo hoá đơn merchant",
        "payout_approved": "Duyệt chi trả",
        "payout_mark_transferred": "Đánh dấu đã chuyển tiền",
        "payout_rejected": "Từ chối chi trả",
        "products_special_create": "Tạo sản phẩm đặc biệt",
        "products_special_update_assignments": "Cập nhật gán sản phẩm đặc biệt",
        "queue_pause": "Tạm dừng hàng đợi",
        "settings_update": "Cập nhật cấu hình",
        "support_ticket_created": "Tạo ticket hỗ trợ",
        "support_ticket_escalated": "Chuyển cấp ticket hỗ trợ",
        "support_ticket_updated": "Cập nhật ticket hỗ trợ",
        "support_ticket_message_created": "Thêm phản hồi ticket hỗ trợ",
        "vendor_capacity_current_active_changed": "Thay đổi năng lực hoạt động nhà cung cấp"
      },
      "targetLabel": "Đối tượng",
      "noDetail": "Không có chi tiết thêm"
    },
    "permissions": {
      "description": "Danh sách quyền hiện hành — gộp từ vai trò gốc và quyền cấp thêm. Hiển thị theo nhóm.",
      "emptyNoPerms": "Tài khoản này chưa được cấp quyền nào."
    },
    "profile": {
      "fields": {
        "name": "Họ tên hiển thị",
        "email": "Email",
        "primaryRole": "Vai trò chính",
        "status": "Trạng thái"
      },
      "statusOptions": {
        "active": "Đang hoạt động",
        "inactive": "Tạm khoá",
        "locked": "Đã khoá vĩnh viễn"
      },
      "selfLockHint": "Không thể tự khoá tài khoản của mình.",
      "roleManagedHint": "Quản lý qua nút Cấp/Thu hồi vai trò ở danh sách người dùng.",
      "statusManagedHint": "Quản lý qua nút Tạm khoá/Bỏ khoá ở danh sách người dùng.",
      "save": "Lưu thay đổi",
      "saving": "Đang lưu...",
      "toast": {
        "updateFailTitle": "Cập nhật thất bại",
        "updateFailDesc": "Không thể lưu thay đổi.",
        "savedTitle": "Đã lưu",
        "savedDesc": "Hồ sơ tài khoản đã cập nhật."
      }
    },
    "sessions": {
      "lastLogin": "Đăng nhập gần nhất",
      "lastIp": "IP gần nhất",
      "activeHeading": "Phiên đang hoạt động",
      "activeAt": "Hoạt động gần nhất",
      "loading": "Đang tải phiên…",
      "loadError": "Không thể tải danh sách phiên.",
      "empty": "Không có phiên đang hoạt động.",
      "unknownDevice": "Thiết bị không xác định",
      "revokeAllHeading": "Đăng xuất tất cả phiên",
      "revokeAllDesc": "Hành động này sẽ huỷ toàn bộ phiên đăng nhập đang hoạt động của tài khoản. Người dùng sẽ buộc phải đăng nhập lại từ mọi thiết bị.",
      "selfNote": "Bạn đang xem tài khoản của mình — không thể tự đăng xuất phiên của mình tại đây. Dùng nút Đăng xuất ở thanh điều hướng nếu cần.",
      "revokeAllBtn": "Đăng xuất tất cả phiên",
      "processing": "Đang xử lý...",
      "confirmTitle": "Xác nhận đăng xuất tất cả phiên",
      "confirmDescLine1": "Bạn có chắc chắn muốn huỷ toàn bộ phiên đang hoạt động của tài khoản này? Người dùng sẽ phải đăng nhập lại trên mọi thiết bị.",
      "confirmDescLine2": "Hành động sẽ được ghi vào nhật ký kiểm toán.",
      "confirmLabel": "Đăng xuất tất cả",
      "toast": {
        "revokedTitle": "Đã đăng xuất phiên",
        "revokedDesc_one": "Đã đăng xuất {{count}} phiên đang hoạt động.",
        "revokedDesc_other": "Đã đăng xuất {{count}} phiên đang hoạt động.",
        "failTitle": "Đăng xuất phiên thất bại",
        "failDesc": "Không thể đăng xuất phiên."
      }
    }
  },
  "impersonate": {
    "button": "Đóng vai",
    "prompt": "Đóng vai {{name}}\n\nNhập lý do (nhật ký kiểm toán, 10-500 ký tự):",
    "reasonTooShortTitle": "Lý do quá ngắn",
    "reasonTooShortDesc": "Cần tối thiểu 10 ký tự cho nhật ký kiểm toán.",
    "failedTitle": "Đóng vai thất bại",
    "invalidResponseTitle": "Phản hồi đóng vai không hợp lệ",
    "invalidResponseDesc": "Máy chủ không trả về redirectUrl.",
    "networkErrorTitle": "Lỗi mạng",
    "unknown": "Không xác định"
  },
  "merchantCredit": {
    "heading": "Lịch sử tín dụng",
    "description": "Tất cả tín dụng đã cấp cho merchant này.",
    "grantNew": "Cấp tín dụng mới",
    "statusLabel": "Trạng thái:",
    "clear": "Xóa lọc",
    "status": {
      "active": "Đang hoạt động",
      "overdue": "Quá hạn",
      "expired": "Hết hạn",
      "revoked": "Đã thu hồi"
    },
    "columns": {
      "status": "Trạng thái",
      "limit": "Hạn mức",
      "remaining": "Còn lại",
      "period": "Chu kỳ (ngày)",
      "start": "Bắt đầu",
      "end": "Kết thúc",
      "created": "Ngày tạo",
      "createdBy": "Người tạo",
      "actions": "Hành động"
    },
    "loading": "Đang tải lịch sử tín dụng…",
    "empty": {
      "title": "Merchant này chưa được cấp tín dụng",
      "bodyWithName": "{{name}} chưa có lịch sử tín dụng nào.",
      "body": "Chưa có lịch sử tín dụng nào.",
      "cta": "Cấp tín dụng đầu tiên"
    },
    "filteredEmpty": "Không có tín dụng nào khớp bộ lọc đã chọn.",
    "rowActions": {
      "edit": "Sửa",
      "revoke": "Thu hồi",
      "viewDetails": "Xem chi tiết",
      "hide": "Ẩn"
    },
    "tx": {
      "loading": "Đang tải giao dịch…",
      "error": "Lỗi tải giao dịch: {{message}}",
      "unknown": "Không xác định",
      "empty": "Chưa có giao dịch (CREDIT_USAGE / CREDIT_PAYMENT) trên tín dụng này.",
      "columns": {
        "type": "Loại",
        "amount": "Số tiền",
        "when": "Thời điểm",
        "txGroup": "tx_group"
      }
    }
  },
  "saleCs": {
    "title": "Gán Sale / CS",
    "titleWithName": "Gán Sale / CS — {{name}}",
    "saleLabel": "Nhân viên Sale (Sale staff)",
    "csLabel": "Nhân viên CS (Customer Support)",
    "saleAria": "Sale phụ trách",
    "csAria": "CS phụ trách",
    "none": "(không có)",
    "loadingList": "Đang tải danh sách…",
    "clearAria": "Xóa {{label}}",
    "cancel": "Huỷ",
    "save": "Lưu",
    "saving": "Đang lưu…",
    "usersError": "Không tải được danh sách nhân viên admin (kiểm tra kết nối hoặc quyền)",
    "toast": {
      "success": "Đã gán Sale/CS",
      "failTitle": "Lưu Sale/CS thất bại",
      "failFallback": "Lưu không thành công"
    }
  },
  "revokeCredit": {
    "title": "Thu hồi tín dụng",
    "debtWarning": "Đã dùng vẫn nợ — merchant sẽ phải trả {{amount}}.",
    "remainingNote": "Số dư còn lại sau thu hồi: {{amount}}. Hành động này không thể hoàn tác.",
    "reasonLabel": "Lý do thu hồi (audit, {{min}}-{{max}} ký tự)",
    "needMoreChars": "Cần thêm {{count}} ký tự",
    "enoughChars": "Đủ độ dài",
    "cancel": "Hủy",
    "submit": "Thu hồi",
    "submitting": "Đang thu hồi…",
    "reasonRequired": "Lý do bắt buộc — tối thiểu 10 ký tự.",
    "failFallback": "Thu hồi thất bại",
    "toast": {
      "successTitle": "Đã thu hồi tín dụng",
      "successDesc": "Lịch sử đã cập nhật."
    }
  },
  "role": {
    "title": "Vai trò",
    "subtitle": "Định nghĩa vai trò admin",
    "columns": {
      "name": "Tên vai trò",
      "userCount": "Số người dùng",
      "permissionCount": "Số quyền",
      "isSystem": "Vai trò hệ thống",
      "updatedAt": "Cập nhật"
    },
    "actions": {
      "create": "Tạo vai trò",
      "edit": "Sửa quyền",
      "duplicate": "Nhân bản",
      "delete": "Xóa"
    },
    "fields": {
      "name": "Tên vai trò",
      "description": "Mô tả",
      "permissions": "Quyền"
    },
    "errors": {
      "cannotDeleteSystem": "Không thể xóa vai trò hệ thống",
      "cannotDeleteInUse": "Không thể xóa — vai trò đang được gán cho {{count}} người dùng",
      "duplicateName": "Đã tồn tại vai trò với tên này"
    },
    "readOnlyBuiltIn": "Role hệ thống — chỉ xem.",
    "readOnlyNoPermission": "Bạn không có quyền chỉnh sửa (cần quyền role:manage).",
    "editor": {
      "titleView": "Xem role: {{name}}",
      "titleEdit": "Sửa role: {{name}}",
      "titleCreate": "Tạo role tùy chỉnh",
      "createBtn": "Tạo role",
      "builtInBanner": "Role hệ thống (built-in) — chỉ xem, không sửa được. Để cấp quyền tùy chỉnh, hãy tạo role mới từ nhóm quyền Admin.",
      "catalogLoadError": "Không tải được danh mục quyền. Thử tải lại trang.",
      "loadingCatalog": "Đang tải danh mục quyền…",
      "fields": {
        "code": "Mã role (slug)",
        "name": "Tên role",
        "description": "Mô tả (tùy chọn)"
      },
      "placeholders": {
        "code": "vd: finance_ops",
        "name": "vd: Finance Operations",
        "description": "Mục đích role và phạm vi đội nhóm"
      },
      "permissionsLegend": "Quyền (Data Permissions)",
      "permissionsHelp": "Cây quyền được nhóm theo module. Quyền có ngưỡng số tiền hiển thị bằng bộ chọn mức — chọn mức không giới hạn sẽ tự động cấp luôn ngưỡng cơ bản.",
      "selectedCountPrefix": "Đã chọn:",
      "selectedCountSuffix": "quyền",
      "validation": {
        "codeMin": "Mã role tối thiểu 2 ký tự",
        "codeMax": "Mã role tối đa 50 ký tự",
        "codePattern": "Mã role chỉ chứa chữ thường, số, dấu gạch dưới",
        "nameMin": "Tên role tối thiểu 2 ký tự",
        "nameMax": "Tên role tối đa 200 ký tự",
        "descMax": "Mô tả tối đa 2000 ký tự",
        "permMin": "Cần ít nhất 1 quyền cho role"
      },
      "toast": {
        "savedTitle": "Đã lưu role",
        "createdTitle": "Đã tạo role",
        "savedDesc": "Role \"{{name}}\" đã được cập nhật.",
        "savedDescCount": "Role \"{{name}}\" đã cập nhật — cấp {{granted}} quyền, thu hồi {{revoked}} quyền.",
        "createdDesc": "Role \"{{name}}\" đã được tạo mới.",
        "saveFail": "Lưu role thất bại."
      }
    },
    "dataPerms": {
      "selectRole": "Chọn một role ở cột bên trái để xem cấu hình quyền dữ liệu.",
      "loading": "Đang tải cấu hình quyền dữ liệu…",
      "loadError": "Không thể tải cấu hình quyền dữ liệu",
      "heading": "Quyền dữ liệu (theo cột)",
      "editableHint": "Cấu hình áp dụng cho danh sách / chi tiết / xuất / báo cáo.",
      "noScreens": "Chưa có màn hình nào đăng ký cấu hình cột.",
      "selectAllAria": "Chọn tất cả cột cho {{name}}",
      "all": "Tất cả",
      "colsSuffix": "cột",
      "toast": {
        "savedDesc": "Cập nhật quyền dữ liệu cho role thành công.",
        "failTitle": "Lưu thất bại",
        "failDesc": "Không thể lưu quyền dữ liệu. Vui lòng thử lại."
      }
    },
    "matrix": {
      "selectRole": "Chọn một role ở cột bên trái để xem ma trận quyền.",
      "loading": "Đang tải ma trận quyền…",
      "loadError": "Không thể tải ma trận quyền",
      "heading": "Ma trận quyền",
      "selectedCount": "Đã chọn {{selected}}/{{total}} quyền.",
      "toast": {
        "savedDesc": "Cập nhật quyền cho role thành công.",
        "failTitle": "Lưu thất bại",
        "failDesc": "Không thể lưu quyền. Vui lòng thử lại."
      }
    },
    "list": {
      "heading": "Roles",
      "subtitle": "Các role hệ thống (Super Admin / Admin / Kế toán / Support) cùng các role tùy chỉnh tạo từ nhóm quyền Admin.",
      "subtitleGate": "Quản lý role và quyền cho admin / super admin.",
      "noReadPermission": "Bạn không có quyền xem danh sách role admin (cần quyền role:read). Liên hệ superadmin.",
      "createBtn": "Tạo role tùy chỉnh",
      "readOnlyBanner": "Bạn chỉ xem được danh sách (chỉ đọc). Tạo / sửa / xóa role yêu cầu quyền role:manage — liên hệ superadmin.",
      "columns": {
        "name": "Tên role",
        "description": "Mô tả",
        "type": "Loại",
        "permissionCount": "Số quyền",
        "memberCount": "Thành viên",
        "actions": "Hành động"
      },
      "loading": "Đang tải danh sách role…",
      "empty": "Chưa có role nào. Liên hệ superadmin để khởi tạo.",
      "typeBuiltIn": "Hệ thống",
      "typeCustom": "Tùy chỉnh",
      "viewPerms": "Xem quyền",
      "edit": "Sửa",
      "delete": "Xóa",
      "deleteBlockedTitle": "Còn {{count}} thành viên đang dùng vai trò này — di chuyển trước khi xóa",
      "confirmDeleteTitle": "Xóa role \"{{name}}\"?",
      "confirmDeleteDesc": "Role {{code}} sẽ bị xóa vĩnh viễn. Thao tác này được ghi vào nhật ký kiểm toán và không thể hoàn tác.",
      "confirmBlockedDesc": "Còn {{count}} thành viên đang dùng vai trò này — di chuyển trước khi xóa. Mỗi admin phải có ít nhất 1 role.",
      "cannotDelete": "Không thể xóa",
      "confirmDeleteLabel": "Xóa role",
      "toast": {
        "deletedTitle": "Đã xóa role",
        "deletedDesc": "Role đã được xóa khỏi hệ thống.",
        "cannotDeleteTitle": "Không thể xóa role",
        "hasMembersWithCount": "Còn {{count}} thành viên đang dùng role này — di chuyển trước khi xóa.",
        "hasMembers": "Role vẫn còn thành viên — di chuyển trước khi xóa.",
        "deleteFailTitle": "Xóa role thất bại",
        "deleteFailFallback": "Xóa role thất bại."
      }
    },
    "permEditor": {
      "title": "Sửa quyền role: {{name}}",
      "defaultReason": "Cập nhật quyền cho vai trò {{role}}",
      "previewSaveError": "Role chưa có mã định danh thực — đang ở chế độ xem trước, không lưu được.",
      "crossScopeError": "Có quyền không thuộc phạm vi admin. Máy chủ từ chối — hãy bỏ chọn quyền liên quan.",
      "saveFail": "Lưu thất bại",
      "previewBannerTitle": "Chế độ xem trước.",
      "previewBannerBody": "Tính năng tải và lưu quyền hiện chưa sẵn sàng. Giao diện nhóm quyền (Billing, Audit, …) đã sẵn sàng để xem trước.",
      "applyWarningPrefix": "Áp dụng ngay cho",
      "applyWarningSuffix": "quản trị viên.",
      "catalogEmpty": "Hệ thống chưa khởi tạo danh mục quyền. Liên hệ superadmin.",
      "legend": "Quyền (theo module)",
      "newBadge": "Mới",
      "impersonateBlocked": "Chặn đóng vai",
      "reasonLabel": "Lý do thay đổi (nhật ký kiểm toán)",
      "reasonPlaceholder": "VD: Cấp quyền billing cho đội tài chính theo ticket #1234",
      "validation": {
        "minOne": "Chọn ít nhất 1 quyền cho role.",
        "crossScope": "Quyền phạm vi merchant không được gán cho admin role: {{keys}}",
        "reasonMin": "Lý do tối thiểu 10 ký tự (yêu cầu của nhật ký kiểm toán).",
        "reasonMax": "Lý do tối đa 500 ký tự."
      },
      "toast": {
        "savedTitle": "Đã lưu quyền role",
        "savedDesc": "+{{added}} quyền · -{{removed}} quyền"
      }
    }
  },
  "permission": {
    "title": "Quyền",
    "categories": {
      "finance": "Tài chính",
      "catalog": "Catalog",
      "orders": "Đơn hàng",
      "users": "Người dùng & Vai trò",
      "support": "Hỗ trợ",
      "merchant": "Quản lý Merchant",
      "vendor": "Quản lý Vendor",
      "system": "Hệ thống"
    },
    "tree": {
      "expandAll": "Mở rộng tất cả",
      "collapseAll": "Thu gọn tất cả",
      "selectAll": "Chọn tất cả",
      "clearAll": "Bỏ chọn tất cả",
      "tierUnlimited": "Không giới hạn",
      "tierUpTo": "≤ {{amount}} USD",
      "empty": "Danh mục quyền trống. Liên hệ superadmin để khởi tạo.",
      "amountGateBadge": "Có cấp số tiền",
      "amountGateHint": "Chọn ngưỡng tối đa cho role này.",
      "thresholdAria": "Ngưỡng cho {{path}}",
      "noGrant": "Không cấp"
    },
    "customBadge": "Tùy chỉnh",
    "domainLabels": {
      "invoice": "Hoá đơn",
      "credit_memo": "Credit memo (ghi nợ)",
      "refund_task": "Tác vụ hoàn tiền",
      "aging_report": "Báo cáo công nợ",
      "legal_entity": "Pháp nhân",
      "pricing": "Định giá",
      "products": "Sản phẩm",
      "product": "Sản phẩm",
      "support": "Hỗ trợ",
      "user": "Quản lý người dùng",
      "admin_user": "Quản lý admin",
      "system": "Hệ thống",
      "dashboard": "Bảng điều khiển",
      "orders": "Đơn hàng",
      "vendors": "Nhà cung cấp",
      "merchants": "Merchant",
      "stores": "Cửa hàng",
      "finance": "Tài chính",
      "impersonate": "Đóng vai"
    }
  },
  "common": {
    "cancel": "Huỷ",
    "save": "Lưu thay đổi",
    "saving": "Đang lưu…",
    "close": "Đóng",
    "saved": "Đã lưu",
    "loading": "Đang tải…",
    "unknownError": "Lỗi không xác định.",
    "all": "Tất cả",
    "delete": "Xóa",
    "continue": "Tiếp tục",
    "retry": "Thử lại",
    "back": "Quay lại"
  },
  "adminMgmt": {
    "twoFa": {
      "title": "Kích hoạt 2FA cho {{name}}",
      "wizardAria": "Trình kích hoạt 2FA",
      "stepsAria": "Các bước kích hoạt 2FA",
      "steps": {
        "setup": "Quét QR",
        "verify": "Nhập mã TOTP",
        "done": "Lưu recovery codes"
      },
      "generatingSecret": "Đang tạo secret 2FA…",
      "qrAlt": "Mã QR 2FA",
      "scanHint": "Quét QR bằng Google Authenticator / Authy / 1Password, hoặc nhập tay secret bên dưới.",
      "continue": "Tiếp tục",
      "setupErrorFallback": "Không khởi tạo được 2FA.",
      "retry": "Thử lại",
      "totpLabel": "Mã 6 chữ số từ ứng dụng Authenticator",
      "back": "Quay lại",
      "verifying": "Đang xác minh…",
      "verify": "Xác minh",
      "recoveryIntro_one": "Lưu {{count}} recovery code dưới đây tại nơi an toàn. Khi mất quyền truy cập app Authenticator, đây là cách DUY NHẤT để đăng nhập lại. Mỗi mã chỉ dùng được một lần.",
      "recoveryIntro_other": "Lưu {{count}} recovery codes dưới đây tại nơi an toàn. Khi mất quyền truy cập app Authenticator, đây là cách DUY NHẤT để đăng nhập lại. Mỗi mã chỉ dùng được một lần.",
      "copy": "Sao chép",
      "downloadTxt": "Tải file .txt",
      "ackLabel_one": "Tôi đã lưu {{count}} recovery code tại nơi an toàn.",
      "ackLabel_other": "Tôi đã lưu {{count}} recovery codes tại nơi an toàn.",
      "ackDownloaded": " (Đã tải file)",
      "finish": "Hoàn tất",
      "recoveryFile": {
        "title": "Printway — Mã khôi phục 2FA",
        "userPrefix": "Người dùng:",
        "generatedPrefix": "Tạo lúc:",
        "instruction": "Lưu file này tại nơi an toàn. Mỗi mã chỉ dùng được một lần."
      },
      "toast": {
        "setupFailTitle": "Không thể khởi tạo 2FA",
        "verifyFailTitle": "Mã 2FA không đúng",
        "copiedTitle_one": "Đã sao chép {{count}} recovery code",
        "copiedTitle_other": "Đã sao chép {{count}} recovery codes",
        "copyFailTitle": "Trình duyệt từ chối clipboard",
        "copyFailDesc": "Hãy tải file recovery codes thay thế."
      }
    },
    "create": {
      "title": "Tạo tài khoản admin",
      "dialogAria": "Tạo admin mới",
      "fields": {
        "email": "Email",
        "name": "Tên hiển thị",
        "role": "Vai trò"
      },
      "emailHint": "Dùng email công ty (@printway.work, @printway.io, @techagents.one). Email mời kèm link đăng nhập lần đầu sẽ được gửi tới địa chỉ này.",
      "roleHint": "Super Admin không có sẵn ở đây — nâng cấp qua hành động trên dòng kèm lý do kiểm toán.",
      "autoGenTitle": "Tự động sinh mật khẩu tạm thời",
      "autoGenHelp": "Mật khẩu sẽ được gửi qua email mời. Tài khoản chỉ hoạt động sau khi hoàn tất 3 bước kích hoạt 2FA.",
      "roleOptions": {
        "admin": "Admin",
        "support_admin": "Support Admin",
        "accountant": "Kế toán",
        "saler": "Saler",
        "manager": "Manager"
      },
      "submit": "Tạo & kích hoạt 2FA",
      "submitLoading": "Đang tạo…",
      "toast": {
        "successTitle": "Đã tạo admin — đã gửi email mời",
        "failTitle": "Không thể tạo admin",
        "successDescription": "{{email}} ({{role}}) sẽ tự đặt mật khẩu và kích hoạt 2FA khi đăng nhập lần đầu."
      },
      "emailPlaceholder": "ten@printway.work"
    }
  },
  "customRoles": {
    "title": "Vai trò tùy chỉnh",
    "subtitle": "Gán vai trò tùy chỉnh cho admin (quyền bổ sung ngoài vai trò chính).",
    "empty": "Chưa gán vai trò tùy chỉnh nào.",
    "placeholder": "Chọn một vai trò tùy chỉnh…",
    "grantBtn": "Gán",
    "granted": "Đã gán vai trò tùy chỉnh",
    "grantError": "Không thể gán vai trò",
    "revoked": "Đã gỡ vai trò tùy chỉnh",
    "revokeError": "Không thể gỡ vai trò",
    "removeAria": "Gỡ vai trò {{role}}"
  }
}
